var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgF7Doc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2647 21.5H16.7353C18.5815 21.5 19.5 20.5695 19.5 18.7262V10.6796C19.5 9.53624 19.3752 9.04016 18.6618 8.31343L13.7389 3.34205C13.0616 2.65049 12.5083 2.5 11.5008 2.5H7.2647C5.42765 2.5 4.5 3.43922 4.5 5.28289V18.7262C4.5 20.5782 5.42765 21.5 7.2647 21.5ZM7.33585 20.0734C6.41733 20.0734 5.93562 19.5856 5.93562 18.6997V5.30935C5.93562 4.43214 6.41733 3.92661 7.34499 3.92661H11.3045V9.0757C11.3045 10.1923 11.8752 10.7417 12.9809 10.7417H18.0644V18.6997C18.0644 19.5856 17.5914 20.0734 16.6641 20.0734H7.33585ZM13.1415 9.40314C12.7937 9.40314 12.6507 9.26173 12.6507 8.90706V4.20149L17.7874 9.40352L13.1415 9.40314Z",
    fill: "#06B6D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF7Doc);
export default __webpack_public_path__ + "static/media/f7_doc.28fcadbfd5cb1c925db310fea29745fc.svg";
export { ForwardRef as ReactComponent };